import { useCallback, useEffect, useMemo, useState } from "react";
import { http, getUserLabels } from "../../lib/api";
import { isTaseronRole } from "../../lib/roles";

// veri girişi tanım + kayıt verileri; odaklanınca tazeleme; seçili projenin şubeleri
// Kayıt listesi: tür seçiliyse o türün tüm kayıtları (en çok 5000), seçili değilse son 500 — canlıda binlerce kayıt varken filtreler eksik veri üzerinde çalışmasın
export const ENTRIES_LIMIT = 5000;
export function useEntryData(isAdmin, projectId, group = null) {
  const [projects, setProjects] = useState([]);
  const [locations, setLocations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [subs, setSubs] = useState([]);
  const [projectSubIds, setProjectSubIds] = useState(null);   // seçili projede var olan taşeronlar (şube/atama/kayıt)
  const [claimLocks, setClaimLocks] = useState([]);
  const [allLocs, setAllLocs] = useState([]);
  const [entries, setEntries] = useState([]);
  const [groupCounts, setGroupCounts] = useState(null);
  const [userLabels, setUserLabels] = useState({});
  const [appUsers, setAppUsers] = useState([]);
  useEffect(() => { getUserLabels().then(setUserLabels); }, []);
  useEffect(() => { if (isAdmin) http.get("/users").then((r) => setAppUsers(r.data.filter((u) => !isTaseronRole(u.role)))).catch(() => {}); }, [isAdmin]);

  const loadEntries = useCallback(() => Promise.all([
    http.get("/entries", { params: { include_cancelled: true, ...(group ? { group, limit: ENTRIES_LIMIT } : { limit: 500 }) } }).then((r) => setEntries(r.data)),
    http.get("/entries/group-counts").then((r) => setGroupCounts(r.data)).catch(() => {}),
  ]), [group]);
  const loadAll = useCallback(() => Promise.all([
    http.get("/projects").then((r) => setProjects(r.data)),
    http.get("/categories").then((r) => setCategories(r.data)),
    http.get("/services").then((r) => setServices(r.data)),
    http.get("/caris", { params: { taseron: 1 } }).then((r) => setSubs(r.data)),
    http.get("/claim-locks").then((r) => setClaimLocks(r.data)),
    http.get("/locations").then((r) => setAllLocs(r.data)).catch(() => {}),
    loadEntries(),
  ]), [loadEntries]);
  useEffect(() => { loadAll(); }, [loadAll]);

  // lokasyonlar yalnız seçili projenin şubeleri; odaklanınca da tazelenir (başka sekmede açılan şube anında gelsin)
  const loadLocations = useCallback(() => {
    if (!projectId) { setLocations([]); setProjectSubIds(null); return Promise.resolve(); }
    http.get(`/projects/${projectId}/subcontractors`).then((r) => setProjectSubIds(new Set(r.data.ids))).catch(() => setProjectSubIds(null));
    return http.get(`/locations?project_id=${projectId}`).then((r) => setLocations(r.data)).catch(() => {});
  }, [projectId]);
  useEffect(() => { loadLocations(); }, [loadLocations]);

  // başka sekmede/sayfada lokasyon eklenip silinirse odaklanınca listeleri tazele
  useEffect(() => {
    const onFocus = () => { loadAll(); loadLocations(); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [loadAll, loadLocations]);

  // taşeron seçenekleri: proje seçiliyse yalnız o projede var olan taşeronlar (düzenlenen kaydın taşeronu korunur)
  const projectSubs = useMemo(() => (projectSubIds ? subs.filter((s) => projectSubIds.has(s.id)) : subs), [subs, projectSubIds]);
  return { projects, locations, categories, services, subs, projectSubs, claimLocks, allLocs, setAllLocs, entries, groupCounts, userLabels, appUsers, loadAll };
}
